



















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import wsApi from '@/apis/onlineLive/wsApi';
import { watch } from 'vue';
import {getAllSlides} from '@/apis/classroom/classroom';
import { Toast, ImagePreview } from 'vant';

@Component({
  components: {
  }
})
export default class RemoteController extends Vue {
    private classtimeid:string = "";//课堂id值
    private courseId:string = "";//课程id值
    private currentIndex = 1;
    private total = 0;
    private interactid = "";
    private pptListData: any = {};
    private currentItem:any = null;
    private showPreview:any = false;

    private loading = false; // 是否显示加载loading
    private finished = true; // 是否已加载完成
    private initFinish = false; // 页面是否初始化完毕

    get userInfo() {
        return this.$store.getters.getUserInfo;
    }

    //用户id值
    get uid() {
        return this.userInfo.id;
    }

    @Watch('interactid')
    onInteractIdChange(newVal:string){
        if(newVal != "" && newVal != undefined && newVal != null){
            getAllSlides({interactid:newVal}).then((res:any)=>{
                this.pptListData = res;
                this.total = Object.keys(this.pptListData).length;
                this.selectPageIndex(this.currentIndex);
            });
        }
    }

    /**
     * 选择某个页码
     */
    selectPageIndex(mIndex:number){
        this.currentIndex = mIndex;
        this.currentItem = this.pptListData[mIndex];
    }

    /**
     * 初始化websocekt
     */
    initSocketCallback() {
        if (window.wsAppModule && window.wsAppModule.status === 3) {
            window.wsAppModule.startInstance();
        }
        window.wsAppModule.on('interactPptPage', (res: { page: string, interactid: string }) => {
            this.currentIndex = Number(res.page);
            this.interactid = res.interactid;
            this.currentItem = this.pptListData[this.currentIndex];
            this.$forceUpdate();
        });
        const toast = Toast.loading({
            duration: 0, // 持续展示 toast
            forbidClick: true,
            message: "正在连接中...."
        });
        setTimeout(() => {
            //请求页码状态
            const wsParams = {
                classId: this.courseId,
                classTimeId: this.classtimeid,
                data: { 
                    id: this.uid,
                    role: 1,
                },
                type: 3//向指定的列表发送消息
            };
            wsApi.studentPptPage(wsParams);
            toast.clear();
        }, 2000);
    }

    created(){
        this.classtimeid = this.$route.query.classtimeid as string;
        this.courseId = this.$route.query.courseId as string;
        let tmpInteractid = this.$route.query.interactid as string;
        if(tmpInteractid != "" && tmpInteractid != undefined && tmpInteractid != null){
            this.interactid = tmpInteractid;
        }
        sessionStorage.setItem('courseId',this.courseId);
    }

    mounted(){
        this.initSocketCallback();
    }

    //全部预览
    previewAll(){
        this.showPreview = true;
    }

    /**
     * 跳转到某页ppt
     */
    gotopptPage(index:number){
        const wsParams = {
            classId: this.courseId,
            classTimeId: this.classtimeid,
            data: { 
                cmd: "goto_page",
                pageindex:index,
            },
            uid: this.uid,
            type:2,
        };
        wsApi.remoteData(wsParams);
        this.showPreview = false;
        this.selectPageIndex(index);
    }

    //下一个动画
    nextAnim(){
        const wsParams = {
            classId: this.courseId,
            classTimeId: this.classtimeid,
            data: { cmd: "ppt_next" },
            uid: this.uid,
            type:2,
        };
        wsApi.remoteData(wsParams);
    }

    //上一个动画
    previousAnim(){
        const wsParams = {
            classId: this.courseId,
            classTimeId: this.classtimeid,
            data: { cmd: "ppt_pre" },
            uid: this.uid,
            type:2,
        };
        wsApi.remoteData(wsParams);
    }

    //退出控制
    exitController(){
        this.$router.push({
            path:'/',
        });
    }
}
